/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* ============================================================================
 * ChokeSports — Duties & Taxes notice popup (cart page)
 * ----------------------------------------------------------------------------
 * Keeps the customer ON the cart page. The "Learn more" link in the cart tax
 * notice opens Warehouse's native modal instead of navigating away.
 *
 * Uses the theme's own ModalManager, which is delegated on document.body, so
 * this survives the cart re-rendering after quantity changes. No theme section
 * file is modified and no extra CSS is required.
 *
 * To edit the wording, change DUTIES_NOTICE below.
 * ========================================================================== */
(function () {
  'use strict';

  var DUTIES_NOTICE = {
    // Which link to intercept. The cart tax notice is the only link in this block.
    linkSelector: '.cart-recap__notices a',

    title: 'Duties &amp; Taxes',

    body:
      '<p>Your order ships direct from our warehouse in Japan, sent express and ' +
      'fully tracked from our door to yours.</p>' +
      '<p>Because it crosses a border, your country may add import duty or tax when ' +
      'it arrives. That amount is set by your local customs authority and collected ' +
      'by the courier on delivery, so it varies by destination and order value.</p>' +
      '<p>Everything ChokeSports charges is shown at checkout, with nothing added ' +
      'later on our side. Each country sets its own rates and thresholds, so we are ' +
      'not able to quote them upfront.</p>',

    // Optional. Leave fullPolicyUrl empty to hide this link.
    fullPolicyUrl: '/pages/duties-taxes',
    fullPolicyLabel: 'What to expect at delivery',

    // Primary dismiss button. Returns the customer to the cart, checkout in view.
    dismissLabel: 'Got it'
  };

  var MODAL_ID = 'modal-duties-notice';

  function buildModal() {
    if (document.getElementById(MODAL_ID)) {
      return;
    }

    var fullPolicy = '';
    if (DUTIES_NOTICE.fullPolicyUrl) {
      fullPolicy =
        '<p><a class="link link--accented" href="' + DUTIES_NOTICE.fullPolicyUrl + '"' +
        ' target="_blank" rel="noopener">' + DUTIES_NOTICE.fullPolicyLabel + '</a></p>';
    }

    var dismiss = '';
    if (DUTIES_NOTICE.dismissLabel) {
      dismiss =
        '<p><button type="button" class="button button--primary" data-action="close-modal">' +
        DUTIES_NOTICE.dismissLabel + '</button></p>';
    }

    var wrapper = document.createElement('div');
    wrapper.innerHTML =
      '<div id="' + MODAL_ID + '" class="modal" aria-hidden="true">' +
        '<div class="modal__dialog" role="dialog" aria-modal="true" aria-label="' + DUTIES_NOTICE.title + '">' +
          '<header class="modal__header">' +
            '<h3 class="modal__title heading h2">' + DUTIES_NOTICE.title + '</h3>' +
            '<button type="button" class="modal__close link" data-action="close-modal" title="Close">' +
              '<svg focusable="false" class="icon icon--close" viewBox="0 0 19 19" role="presentation">' +
                '<path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path>' +
              '</svg>' +
            '</button>' +
          '</header>' +
          '<div class="modal__content"><div class="rte">' + DUTIES_NOTICE.body + fullPolicy + dismiss + '</div></div>' +
        '</div>' +
      '</div>';

    // Appended to body so a cart re-render never removes it.
    document.body.appendChild(wrapper.firstChild);

    // Hidden trigger: clicking it lets the theme's own ModalManager open the
    // modal, so we inherit focus handling, Escape, click-outside and body lock.
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.id = MODAL_ID + '-trigger';
    trigger.setAttribute('data-action', 'open-modal');
    trigger.setAttribute('aria-controls', MODAL_ID);
    trigger.setAttribute('hidden', 'hidden');
    trigger.style.display = 'none';
    document.body.appendChild(trigger);
  }

  function markLinks() {
    var links = document.querySelectorAll(DUTIES_NOTICE.linkSelector);
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('aria-haspopup', 'dialog');
    }
  }

  function onClick(event) {
    var link = event.target.closest ? event.target.closest(DUTIES_NOTICE.linkSelector) : null;
    if (!link) {
      return;
    }

    event.preventDefault();
    buildModal();

    var trigger = document.getElementById(MODAL_ID + '-trigger');
    if (trigger) {
      trigger.click();
    }
  }

  function init() {
    if (!document.querySelector('[data-section-type="cart"]')) {
      return; // not the cart page
    }
    buildModal();
    markLinks();
  }

  document.addEventListener('click', onClick);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('cart:refresh', markLinks);
  document.addEventListener('shopify:section:load', init);

  if (document.readyState !== 'loading') {
    init();
  }
})();
